<template>
  <div
    class="branch-info-wrap"
    :class="{'scroll-marker': unreadCount}">
    <router-link
      class="panel-item"
      :class="{active: active}"
      :to="{ name: goToName, params: { organisationId: orgToLoad, businessId: branch.id } }"
      @click.native="resetIfNeeded">
      <div class="flex flex-align-center">
        <span class="branch-icon-wrapper small no-shrink">
          <span
            v-if="!numberIntegrationMap[branch.id] || !numberIntegrationMap[branch.id].length"
            class="business-icon flex center-all emoji-fix">{{ branch.emoji }}</span>
          <span
            v-else-if="numberIntegrationMap[branch.id] && numberIntegrationMap[branch.id].length === 1"
            :class="[numberIntegrationMap[branch.id][0]]" />
          <span
            v-else
            class="" >{{ numberIntegrationMap[branch.id].length }}</span>
        </span>
        <div class="number-info flex column greedy ellipsis-wrapper">
          <h3
            class="ellipsis"
            :inner-html.prop="branch.name" />
          <p
            class="ellipsis"
            :inner-html.prop="branch.phone | phoneFormat" />
        </div>
        <!-- <span
          v-if="unreadCount"
          class="count-unread ml-2 flex center-all no-shrink"
          :class="{hide: menuOpen}" >{{ unreadCount | nineNinePlus }}</span> -->
        <span
          v-if="unreadCount2"
          class="count-unread ml-2 flex center-all no-shrink"
          :class="{hide: menuOpen}" >{{ unreadCount2 | nineNinePlus }}</span>
        <span
          :id="`branch-${randomId}`"
          class="menu-button flex center-all no-shrink"
          :class="{active: menuOpen}"
          @click.stop.prevent="toggleMenu"/>
      </div>
    </router-link>
    <!--    <div-->
    <!--      v-if="active"-->
    <!--      class="branch-details">-->
    <!--      <div class="stat-row flex flex-align-center">-->
    <!--        <span class="branch-details-icon unassigned" />-->
    <!--        <span class="title greedy">Unassigned</span>-->
    <!--        <span class="value">?</span>-->
    <!--      </div>-->
    <!--    </div>-->
  
    <b-popover
      ref="branchFilterPopover"
      :target="`branch-${randomId}`"
      triggers="manual"
      :show="menuOpen"
      placement="bottomright"
      fallback-placement="flip"
      :delay="0"
      :no-fade="true"
      custom-class="interactive-popover branch-popover hide-arrow m-0 ml-2"
      boundary-padding="-299" >
      <div
        :id="'menu-' + branch.id"
        v-click-outside="closeMenu"
        class="menu">
        <section class="animation-view flex">
          <div
            class="main-view"
            :class="{'go-out': showAwailabilityView, 'min-height': !showMain}" >
            <section class="padded flex flex-align-center" >
              <div class="branch-icon-wrapper">
                <VNodes :vnodes="getNumberIcon(branch)"/>
              </div>
              <div class="option-info">
                <h3
                  class="ellipsis"
                  :inner-html.prop="branch.name" />
                <p
                  class="ellipsis"
                  :inner-html.prop="branch.phone | phoneFormat" />
              </div>
            </section>
            <section
              class="padded availability"
              @click="availabilityToggle" >
              <div
                class="flex center-all status-wrap">
                <span
                  class="status"
                  :class="{unavailable: !branchAvailable}" />
                <span class="status222">{{ branchAvailable ? 'Open for business' : 'Closed for business' }}</span>
                <SBIcon
                  :id="'description-' + branch.id"
                  :icon="SBIconList.INFO"
                  :color="SBColors.greyPrimary"
                  :size="12" />
                <div class="greedy" />
                <SBIcon
                  :icon="SBIconList.DOWN_ARROW"
                  class="rotate-270"
                  :color="SBColors.greyPrimary"
                  :size="12" />
              </div>
              <b-popover
                :target="'description-' + branch.id"
                triggers="hover"
                placement="top"
                custom-class="branch-menu-popover" >
                {{ availabilityTooltipTopText }}
                <br>
                <br>
                Set up <router-link :to="{ name: 'WorkingHours', params: { numberId: branch.id } }">working hours</router-link> and edit <router-link :to="{ name: 'AutomatedResponsesSettings', params: { numberId: branch.id }, query: { 'show-response': branchAvailable ? 'default' : 'away' } }" >{{ branchAvailable ? 'welcome' : 'away' }} message</router-link> in the number settings.
              </b-popover>
            </section>
            <section
              class="hoverable"
              @click="navigateTo({name: 'WorkingHours', params: { organisationId: orgToLoad, numberId: branch.id }})">
              <span class="number-icon working-hours" />
              Set up working hours
            </section>
            <section
              class="hoverable"
              @click="navigateTo({ name: 'AutomatedResponsesSettings', params: { numberId: branch.id }, query: { 'show-response': 'default' } })">
              <span class="number-icon welcome-message" />
              Edit welcome message
            </section>
            <section
              class="hoverable"
              @click="navigateTo({ name: 'AutomatedResponsesSettings', params: { numberId: branch.id }, query: { 'show-response': 'away' } })">
              <span class="number-icon away-message" />
              Edit away message
            </section>
            <section
              v-clipboard="url"
              class="hoverable"
              @success="copyNumber"
              @error="copyNumber(false)">
              <span
                class="number-icon copy-number" />
              {{ copyNumberText }}
            </section>
            <section
              class="hoverable"
              @click="openAddMemberModal">
              <span class="number-icon team-members" />
              Add team members
            </section>
            <!-- <section
              class="hoverable last"
              @click="navigateTo({ name: 'BusinessProfile', params: { numberId: branch.id } })">
              <span class="number-icon settings" />
              Settings
            </section> -->
            <section
              class="hoverable last"
              @click="showSettingsModal">
              <span class="number-icon settings" />
              Edit number
            </section>
          </div>
          <div
            class="availability-view"
            :class="{'go-in': showAwailabilityView, 'min-height': !showAvailability}">
            <div
              class="header relative no-user-select" >
              <SBIcon
                :icon="SBIconList.DOWN_ARROW"
                class="rotate-90 relative back-icon show-hand"
                :color="SBColors.greyPrimary"
                :size="12"
                hover-color="#f7f9fb"
                :hover-icon-color="SBColors.blackPrimary"
                :hover-size="24"
                @click="availabilityToggle" />
              <h3>Number availability</h3>
            </div>
            <div
              v-if="showAvailabilityInfo"
              class="availability__info flex center-all"
              @click="navigateTo({ name: 'WorkingHours', params: { numberId: branch.id } })" >
              <SBIcon
                :icon="SBIconList.INFO"
                :color="SBColors.blackPrimary"
                :size="12" />
              <p>Set up working hours to automatically update number availability status.</p>
              <SBIcon
                :icon="SBIconList.CLOSE_THIN"
                color="#B4AD99"
                :hover-icon-color="SBColors.blackPrimary"
                :size="9"
                @click.native.stop="hideAvailabilityInfo" />
            </div>

            <div
              class="availability__opened"
              :class="{selected: branchAvailable}"
              @click="toggleAvailability(true)" >
              <div class="availibility-header flex center-all">
                <span
                  class="status" />
                <p class="greedy m-0">Open for business</p>
                <SBIcon
                  v-if="branchAvailable"
                  :icon="SBIconList.DONE_TICK"
                  :color="SBColors.blackPrimary"
                  :hover-icon-color="SBColors.blackPrimary"
                  :size="9" />
              </div>
              <p class="info">
                Contacts that message this number will receive an automated
                <router-link
                  :to="{ name: 'AutomatedResponsesSettings', params: { numberId: branch.id }, query: { 'show-response': 'default' } }"
                  @click.native="closeMenu()"
                  @click.native.stop >welcome message</router-link>, indicating that you are open for business.
              </p>
            </div>

            <div
              class="availability__closed"
              :class="{selected: !branchAvailable}"
              @click="toggleAvailability(false)" >
              <div class="availibility-header flex center-all">
                <span
                  class="status unavailable" />
                <p class="greedy m-0">Closed for business</p>
                <SBIcon
                  v-if="!branchAvailable"
                  :icon="SBIconList.DONE_TICK"
                  :color="SBColors.blackPrimary"
                  :hover-icon-color="SBColors.blackPrimary"
                  :size="9" />
              </div>
              <p class="info">
                Contacts that message this number will receive an automated
                <router-link
                  :to="{ name: 'AutomatedResponsesSettings', params: { numberId: branch.id }, query: { 'show-response': 'away' } }"
                  @click.native="closeMenu()"
                  @click.native.stop >away message</router-link>, indicating that you are closed for business.
              </p>
            </div>
          </div>
        </section>
      </div>
    </b-popover>

    <InviteTeamMembersModal
      ref="inviteTeamMemberModalRef" />

    <EditNumberModal
      ref="editNumberModal"
      :number="branch"
      :members="organisationMembers || []"
      :icon-index="currentOrganisation.businesses.findIndex(business => business.phone === branch.phone)" />

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import SBIcon from '@/components/common/Icon';
import SBColors from '@/helpers/lists/colors';
import SBIconList from '@/helpers/lists/sb-icon-list';
import ClickOutside from 'v-click-outside';
import SwitchCheckbox from '../../common/SwitchCheckbox';
import ToasterMixin from '@/mixins/Toaster';
import InviteTeamMembersModal from '@/components/business/settings/modals/InviteTeamMembers.modal';
import EditNumberModal from '@/components/business/settings/modals/EditNumber.modal';
import { getLastOrgId } from '@/helpers/localStorage.helpers';
import randomString from '@/helpers/randomString';
import { getNumberIcon } from '@/helpers/lists/branchIcons';
import VNodes from '@/components/common/VNodes';

export default {
  name: 'BranchInfo',
  directives: {
    ClickOutside: ClickOutside.directive,
  },
  components: {
    SwitchCheckbox,
    VNodes,
    SBIcon,
    InviteTeamMembersModal,
    EditNumberModal,
  },
  mixins: [
    ToasterMixin,
  ],
  props: {
    organisationId: {
      type: String,
      required: true,
    },
    branch: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconIndex: { // TODO this is just temporary - remove once users will be able to chose icons
      type: Number,
      required: false,
      default: 1,
    },
    lock: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      showAwailabilityView: false,
      SBIconList,
      SBColors,
      menuOpen: false,
      copyNumberSuccess: false,
      ignoreMenuClose: false,
      showMain: true,
      showAvailability: false,
      showAvailabilityInfo: true,
      integrationIcon: {
        FRONTAPP: 'integration-front-color.svg',
        FRONTPACHA: 'integration-front-color.svg',
      },
      randomId: randomString(),
    };
  },
  computed: {
    ...mapGetters({
      unreadConversationsCount: 'chat/unreadConversationsCount',
      statistics: 'organisation/statistics',
      currentOrganisation: 'organisation/currentOrganisation',
      organisationMembers: 'organisation/currentOrganisationMembers',
      numberIntegrationMap: 'organisation/numberIntegrationMap',
      localStatsOffsetCount: 'organisation/localStatsOffsetCount',
      localStatsOffsetIds: 'organisation/localStatsOffsetIds',
      localStatsOffsetMyChatCount: 'organisation/localStatsOffsetMyChatCount',
      unreadCounter: 'chat/unreadCounter',
      me: 'organisation/me',
    }),
    copyNumberText() {
      // if (this.copyNumberSuccess) {
      //   return 'Copied!';
      // }
      return 'Copy WhatsApp click-to-chat link';
    },
    branchAvailable() {
      return this.branch.available;
    },
    url() {
      let phone = String(this.branch.phone);
      phone = phone.substring(phone.startsWith('+') ? 1 : 0);

      return `https://wa.me/${phone}`;
    },
    isManageScreen() {
      return this.$route && this.$route.meta && this.$route.meta.manageScreen;
    },
    goToName() {
      let targetName = 'OrganisationBusiness';
      if (this.isManageScreen) {
        targetName = this.$route.name;
      }
      return targetName;
    },
    availabilityTooltipTopText() {
      if (this.branchAvailable) {
        return 'Contacts that message this number will ' +
          'receive an automated welcome message, ' +
          'indicating that you are open for business.';
      }
      return 'Contacts that message this number will ' +
        'receive an automated away message, ' +
        'indicating that you are closed for business.';
    },
    orgToLoad() {
      return this.organisationId || getLastOrgId();
    },
    unreadCount() {
      let allUnread = this.statistics && this.statistics[this.branch.id] && this.statistics[this.branch.id].open.all_unread ? this.statistics[this.branch.id].open.all_unread : 0;
      let userUnread = this.statistics && this.statistics[this.branch.id] && this.statistics[this.branch.id].open.user_unread[this.me.id] ? this.statistics[this.branch.id].open.user_unread[this.me.id] : 0;
      allUnread = parseInt(allUnread, 10) + (this.localStatsOffsetCount[this.branch.id] ? this.localStatsOffsetCount[this.branch.id] : 0) + (this.localStatsOffsetIds[this.branch.id] ? this.localStatsOffsetIds[this.branch.id].length : 0);
      allUnread = parseInt(allUnread, 10) >= 0 ? parseInt(allUnread, 10) : 0;

      if (this.localStatsOffsetMyChatCount[this.branch.id]) {
        userUnread += this.localStatsOffsetMyChatCount[this.branch.id];
      }

      const counterValue = Math.max(allUnread, userUnread);
      return counterValue < 0 ? 0 : counterValue;

      // Min count zero is set in action but if that will not be enough then use the code below
      // const allUnread = this.statistics && this.statistics[this.branch.id] && this.statistics[this.branch.id].open.all_unread && parseInt(this.statistics[this.branch.id].open.all_unread, 10) >= 0 ? this.statistics[this.branch.id].open.all_unread : 0;
      // const userUnread = this.statistics && this.statistics[this.branch.id] && this.statistics[this.branch.id].open.user_unread[this.me.id] && parseInt(this.statistics[this.branch.id].open.user_unread[this.me.id], 10) >= 0 ? this.statistics[this.branch.id].open.user_unread[this.me.id] : 0;
    },
    unreadCount2() {
      let counter = 0;
      try {
        counter = this.unreadCounter[this.branch.id].counter;
      } catch (error) { /* do nothing */ }
      return counter;
    },
  },
  watch: {
    menuOpen(val) {
      if (val) {
        // if opening, tell other menus to close
        this.$eventBus.$emit('branch-menu-open', this.branch.id);
      } else {
        // if closing menu, clear number copied
        this.copyNumberSuccess = false;
      }
    },
    // statistics() {
    //   console.log('title - a');
    //   let allUnread = this.statistics && this.statistics[this.branch.id] && this.statistics[this.branch.id].open.all_unread ? this.statistics[this.branch.id].open.all_unread : 0;
    //   console.log('title - b');
    //   allUnread = parseInt(allUnread, 10) + (this.localStatsOffsetCount[this.branch.id] ? this.localStatsOffsetCount[this.branch.id] : 0) + (this.localStatsOffsetIds[this.branch.id] ? this.localStatsOffsetIds[this.branch.id].length : 0);
    //   console.log('title - c');
    //   allUnread = parseInt(allUnread, 10) >= 0 ? parseInt(allUnread, 10) : 0;
    //   console.log('title shoud change', allUnread);
    // },
  },
  mounted() {
    this.$eventBus.$on('branch-menu-open', this.closeMenuCheck);

    if (!localStorage.getItem('hideAvailabilityInfo')) {
      localStorage.setItem('hideAvailabilityInfo', false);
    }

    this.showAvailabilityInfo = localStorage.getItem('hideAvailabilityInfo') === 'false';
    window.addEventListener('storage', () => {
      this.showAvailabilityInfo = localStorage.getItem('hideAvailabilityInfo') === 'false';
    });
  },
  beforeDestroy() {
    this.$eventBus.$off('branch-menu-open', this.closeMenuCheck);
  },
  methods: {
    ...mapActions({
      setBusinessAvailability: 'organisation/setBusinessAvailability',
      resetConversationList: 'chat/resetConversationList',
    }),
    getNumberIcon,
    availabilityToggle() {
      this.showAwailabilityView = !this.showAwailabilityView;
      if (this.showAwailabilityView) {
        this.showAvailability = true;
        setTimeout(() => {
          this.showMain = false;
        }, 80);
      } else {
        this.showMain = true;
        setTimeout(() => {
          this.showAvailability = false;
        }, 80);
      }
    },
    closeMenuCheck(branchId) {
      // we need to close this menu if another is open
      if (branchId !== this.branch.id) {
        this.closeMenu();
      }
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
      this.showAwailabilityView = false;
      this.showAvailability = false;
      this.showMain = true;
    },
    toggleAvailability(toggle = null) {
      if (toggle === null || toggle !== this.branchAvailable) {
        this.setBusinessAvailability({ businessId: this.branch.id, isAvailable: !this.branchAvailable }).then(() => {
          this.showToaster('Number availability has been successfully updated.', null, null, 'OK');
        });
        this.availabilityToggle();
      }
    },
    copyNumber(success = true) {
      if (success) {
        this.copyNumberSuccess = true;
      } else {
        // this.linkError = true;
      }

      // remove copy info after 3 seconds
      setTimeout(() => {
        this.copyNumberSuccess = false;
        // this.linkError = false;
      }, 3000);

      this.closeMenu();
      this.showToaster('Copied to clipboard.', null, null, 'OK');
    },
    hideAvailabilityInfo() {
      localStorage.setItem('hideAvailabilityInfo', true);
      window.dispatchEvent(new Event('storage'));
    },
    navigateTo(routeParams) {
      this.$router.push(routeParams).catch(() => {}).catch(() => {});
      this.closeMenu();
    },
    openAddMemberModal() {
      this.closeMenu();
      this.$refs.inviteTeamMemberModalRef.show();
      this.$refs.inviteTeamMemberModalRef.preselectNumbers(this.branch.id);
    },
    resetIfNeeded() {
      this.resetConversationList(true);
    },
    showSettingsModal() {
      this.closeMenu();
      this.$refs.editNumberModal.show(this.branch);
    },
  },
};
</script>

<style lang="scss" scoped>
.branch-info-wrap {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: left;
  color: $blackPrimary;
  position: relative;
  border-radius: 6px;
  margin-bottom: 8px;

  &:hover {
    background-color: $linkHover;
  }

  &:has(.panel-item.active) {
    background-color: $linkActive;
  }
}

.panel-icon-wrap {
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px;
  border-radius: 6px;
  box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.05);
  border: solid 1px #e0e3e5;
  background-color: #fdfefe;
}

.panel-item {
  font-family: HelveticaNeue, sans-serif;
  text-decoration: none;
  padding: 5px 6px;
  display: block;
  border-radius: 6px;

  .number-info {
    margin-left: 13px;

    h3 {
      font-size: 13px;
      font-weight: 400;
      color: $blackPrimary;
    }

    p {
      font-size: 11px;
      font-weight: normal;
      color: $blackUltralight;
    }
  }

  .title {
    padding-left: 12px;

    &.lock::after {
      content: '';
      width: 15px;
      height: 13px;
      display: inline-block;
      mask-image: url(~@/assets/img/SB-Icons/lock-closed.svg);
      mask-size: 10px auto;
      mask-repeat: no-repeat;
      mask-position: center right;
      background-color: $greyPrimary;
    }
  }

  .count-unread {
    padding: 1px 6px 1px 6px;
    border-radius: 8px;
    background-color: $redPrimary;
    font-size: 11px;
    font-weight: 500;
    color: $white;
    height: 16px;

    &.hide {
      display: none !important;
    }
  }

  // default menu button state: no background
  .menu-button {
    width: 0;
    height: 16px;
    border-radius: 6px;
    border: solid 1px rgba(0, 0, 0, 0);
    margin-right: 0px !important;
    margin-left: 0px !important;
    color: $blackUltralight;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 16px 16px;

    // menu button state when button is hovered or menu is open
    &:hover, &.active {
      margin-left: 8px !important;
      width: 28px !important;
      box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.3);
      color: #2a383f;
      background-image: url('~@/assets/img/SB-Icons/menu-3-dots-dark.svg') !important;
      border: solid 1px #e0e3e5;
      background-color: #fdfefe;
    }
  }

  // menu button has to be visible when parent panel-item is hovered
  &:hover {
    .menu-button {
      margin-left: 8px !important;
      width: 28px !important;
      background-image: url('~@/assets/img/SB-Icons/menu-3-dots-light.svg');
    }

    .count-unread {
      display: none !important;
    }
  }
}

// business icons
.business-icon {
  width: 14px;
  height: 14px;
  font-size: 10px;
  position: relative;
  top: 1px;
  font-family: 'apple color emoji,android emoji,emojione mozilla,twemoji mozilla,segoe ui emoji,noto color emoji,emojisymbols,segoe ui symbol';

  &.small {
    margin-right: 4px;
    width: 14px;
    height: 14px;
    font-size: 14px;
  }
}

.branch-details {
    padding-left: 44px;

    .branch-details-icon {
      height: 14px;
      width: 14px;
      margin-right: 8px;
      display: inline-block;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;

      &.unassigned {
        background-image: url('~@/assets/img/SB-Icons/panel-unassigned.svg');
      }
    }
}

.stat-row {
    padding: 8px 0;
}

// links
a {
  text-decoration: none !important;
  color: $blackPrimary;

  &:hover {
    background-color: $linkHover;
    text-decoration: none;
  }
  // highlight EXACT route match
  &.active {
    background-color: $linkActive;
  }
}

.menu {
    // position: absolute;
    // top: 31px;
    // left: 195px;
    width: 299px;
    border-radius: 5px;
    box-shadow: 0 2px 5px 0 rgba(13, 15, 22, 0.23);
    background-color: $white;
    z-index: 100;
    overflow: hidden;

    section {
        // border-bottom: solid 1px $greyBorderModal; // #e0e7e9;

        &.padded {
            padding: 14px 12px;
        }

        &.hoverable {
            height: 44px;
            display: flex;
            align-items: center;

            .number-icon {
                display: inline-block;
                background-repeat: no-repeat;
                background-position: center;
                width: 40px;
                height: 44px;
                background-size: 16px 16px;

                &.working-hours { background-image: url('~@/assets/img/SB-Icons/working-hours-light.svg'); }
                &.welcome-message { background-image: url('~@/assets/img/SB-Icons/welcome-message-light.svg'); }
                &.away-message { background-image: url('~@/assets/img/SB-Icons/away-message-light.svg'); }
                &.team-members { background-image: url('~@/assets/img/SB-Icons/invite-team-members-light.svg'); }
                &.settings { background-image: url('~@/assets/img/SB-Icons/settings-light.svg'); }
                &.copy-number { background-image: url('~@/assets/img/SB-Icons/copy-light.svg'); }
                &.copy-number-done { background-image: url('~@/assets/img/SB-Icons/message-tick-blue.svg'); }
            }
            &:hover {
              background-color: $hover;
              cursor: pointer;
              .number-icon {
                // &.working-hours { background-image: url('~@/assets/img/SB-Icons/working-hours-dark.svg'); }
                // &.welcome-message { background-image: url('~@/assets/img/SB-Icons/welcome-message-dark.svg'); }
                // &.away-message { background-image: url('~@/assets/img/SB-Icons/away-message-dark.svg'); }
                // &.team-members { background-image: url('~@/assets/img/SB-Icons/invite-team-members-dark.svg'); }
                // &.settings { background-image: url('~@/assets/img/SB-Icons/settings-dark.svg'); }
                // &.copy-number { background-image: url('~@/assets/img/SB-Icons/copy-dark.svg'); }
              }

            }
          // copy number
          &.copied {
            color: #2680eb;
          }
        }

        &.last {
            border-bottom: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
        }

    }

    .name {
        color: #141c20;
        font-weight: 500;
    }
    .phone {
        color: $blackLight; // #54626c;
        margin-top: 2px;
    }
}

.status {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background-color: $greenPrimary; // #ff5b61;
  margin: 0 15px 0 3px;

  &.unavailable {
    background-color: $redPrimary;
  }
}

.availability {
  border-top: solid 1px $greyBorderModal;
  border-bottom: solid 1px $greyBorderModal;

  &.branchAvailable {

    .status {
        color: $greenPrimary; // #00bfa5;
    }
  }

  &:hover {
    background-color: $hover;
    cursor: pointer;
    user-select: none;
  }
}

.branch-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  width: 34px;
  border-radius: 6px;
  box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.05);
  border: solid 1px #e0e3e5;
  background-color: #fdfefe;

  .branch-icon {
    font-size: 13px !important;
    // letter-spacing: 3px !important;
    top: 1px;
    position: relative;
  }

  img {
    width: 14px;
  }

  .FRONTAPP,
  .FRONTPACHA {
    background-image: url('~@/assets/img/SB-Icons/integration-front-color.svg');
    background-size: 14px 14px;
    background-position: center center;
    background-repeat: no-repeat;
    display: block;
    width: 100%;
    height: 100%;
  }

  &.small {
    height: 28px;
    width: 28px;
  }
}

.option-info {
  margin-left: 8px;
  max-width: calc(100% - 42px);

  h3 {
    font-size: 14px;
    font-weight: 500;
    color: $blackPrimary;
  }

  p {
    font-size: 12px;
    font-weight: 400;
    color: $greyPrimary;
    margin: 3px 0 0 0 !important;
  }
}

.status-wrap .sb-icon {
  margin-left: 7px;
}

.rotate-270 {
  transform: rotate(270deg);
}

.rotate-90 {
  transform: rotate(90deg);
}

.animation-view {
  width: 200%;
  display: flex;
  // border-top: solid 1px $greyBorderModal;

  .main-view {
    width: 100%;
    max-width: 299px;
    transition: all .08s ease-in;

    &.go-out {
      transform: translateX(-100%);
    }
  }

  .availability-view {
    width: 100%;
    transition: all .08s ease-in;

    .header {
      border-bottom: solid 1px $greyBorderModal;

      h3 {
        font-size: 14px;
        font-weight: 500;
        padding: 15px 27px;
        text-align: center;
        color: #2a383f;
      }
    }

    &.go-in {
      transform: translateX(-100%);
    }

    .availability__info,
    .availability__opened,
    .availability__closed {
      border-radius: 5px;
      margin: 15px;
    }

    .availability__opened,
    .availability__closed {
      padding: 15px;

      &:not(.selected):hover {
        background-color: #f7f9fb;
        cursor: pointer;
      }

      .availibility-header p {
        font-size: 14px;
        font-weight: 500;
      }

      .info {
        margin-top: 10px;
        font-size: 14px;
        font-weight: 400;
        color: $greyPrimary;
        user-select: none;

        a {
          color: inherit;
          text-decoration: underline !important;

          &:hover {
            color: $blackPrimary;
            background: none;
          }
        }
      }
    }

    .availability__info {
      background: #fff7dd;
      padding: 10px 15px;

      &:hover {
        cursor: pointer;
        box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.15);
        padding: 9px 14px;
        border: solid 1px #f5edce;
      }

      p {
        margin: 0 15px;
        user-select: none;
      }
    }

    .availability__opened {
      &.selected {
        background-color: #f0fcfb;
      }
    }

    .availability__closed {
      &.selected {
        background-color: #fff5f6;
      }
    }
  }

  .min-height {
    max-height: 1px;
    overflow: hidden;
  }
}

.back-icon {
  position: absolute;
  top: calc(50% - 12px);
  left: 10px;
}
</style>
